import { PDFSectionIds } from '../../../public-api';
import { ICoverData } from './cover-data.interface';
import { ICustomerData } from './customer-data.interface';
import { INotesDetails } from './notes-details.interface';
import { IOptions } from './options.interface';
import { IOrganizationData } from './organization-data.interface';
import { ISectionData } from './section-data.interface';
import { ISignatureData } from './signature-data.interface';
import { IText } from './text.interface';

export interface IPdfTronData {
    cover: ICoverData;
    customer: ICustomerData;
    organization: IOrganizationData;
    options: IOptions;
    signatures: ISignatureData;
    date: string;
    sections: ISectionData[];
    orderedSectionsIds: PDFSectionIds[];
    orderedSectionsTitles: string[];
    notesDetails: INotesDetails[];
    sectionIdToTitle: { [key: string]: string };
    text: IText;
    /** FX (REV-21512): the report keeps its books in a functional currency and shows a display
     *  currency next to it. Independent of any print option — a template block conditioned on it
     *  (`{#isFxReport}…{/isFxReport}`) holds for every FX report. */
    isFxReport: boolean;
    //Static Optional Sections
    //Balance Sheet
    hasBs: boolean;
    bs?: ISectionData;
    //Income Statment
    hasIs: boolean;
    is?: ISectionData;
    //Cash Flow Statment
    hasCfs: boolean;
    cfs?: ISectionData;
    //Notes
    hasNts: boolean;
    nts?: ISectionData;
    //Apropriation of Profit
    hasAOP: boolean;
    aop?: ISectionData;
    //Financial Closing Process
    hasFcp: boolean;
    fcp?: ISectionData;
    //Fixed Assets Schedule
    hasFas: boolean;
    fas?: ISectionData;
    //All Complementary Reports
    hasCrs: boolean;
    crs?: ISectionData[];
    //Complementary Reports in the start
    crsA01?: ISectionData[];
    hasCrsA01: boolean;
    //Complementary Reports at the end
    crsA02?: ISectionData[];
    hasCrsA02: boolean;
    //Complementary Reports as appendix
    crsA03?: ISectionData[];
    hasCrsA03: boolean;
    //Equity Movement Schedule
    hasEms: boolean;
    ems?: ISectionData;
    //Account Proof Balance Sheet
    hasApbs: boolean;
    apbs?: ISectionData;
    //Account Proof Income Statement
    hasApis: boolean;
    apis?: ISectionData;
    currency: string;
}
